import { ExternalLink } from 'lucide-react';
import React from 'react';

/**
 * A bold slug/label in an admin list row that opens its live website URL in a
 * new tab. The full URL shows on hover (title) so editors can jump to the
 * public page without knowing the path. Stops row-click propagation so it
 * doesn't also open the edit screen.
 */
export function ViewOnSiteLink({
  href,
  label,
}: {
  href: string;
  label: string;
}): React.JSX.Element {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      title={href}
      onClick={(e) => e.stopPropagation()}
      className="inline-flex w-fit items-center gap-1 text-xs font-semibold text-zinc-700 hover:text-blue-600 hover:underline"
    >
      {label}
      <ExternalLink className="h-3 w-3 opacity-50" />
    </a>
  );
}
